module.exports = __webpack_public_path__ + "img/nextstep.9d16486a.svg";